import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import BoatIcon from '@assets/images/Boat.svg';

import { ProgressButton, setSelectedActivity } from '../../../common';
import { datesShape } from '../../constants';
import { openCreateLongCruise } from '../../duck';

class CreateLongCruiseButton extends React.PureComponent {
  handleClick = () => {
    const { onOpenCreateLongCruise, onClick } = this.props;
    onOpenCreateLongCruise();
    if (onClick) {
      onClick();
    }
  };

  render() {
    const { title, disabled, className, children, replaceButton } = this.props;
    const button = replaceButton ? (
      React.cloneElement(replaceButton, { onClick: this.handleClick })
    ) : (
      <ProgressButton
        color="scouting-warm-gray"
        noBorder
        fitText
        title={title}
        disabled={disabled}
        icon={<BoatIcon />}
        className={className}
        onClick={this.handleClick}
      >
        {children || <FormattedMessage id="progress.longCruise.label" />}
      </ProgressButton>
    );
    return button;
  }
}

CreateLongCruiseButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  dates: datesShape,
  onClick: PropTypes.func,
  onOpenCreateLongCruise: PropTypes.func.isRequired,
  allowRemovePersons: PropTypes.bool,
  replaceButton: PropTypes.node,
};

const mapDispatch = (
  dispatch,
  { dates, allowAddPersons, activityData, allowRemovePersons },
) => ({
  onOpenCreateLongCruise: () => {
    dispatch(openCreateLongCruise(dates, allowAddPersons, allowRemovePersons));
    activityData && dispatch(setSelectedActivity(activityData));
  },
});

export default connect(null, mapDispatch)(CreateLongCruiseButton);
